export default __webpack_public_path__ + "static/media/8.70265f18.svg";